import { Injectable } from '@angular/core';
import { Router, CanActivate, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from './Authentication.service';

@Injectable()
export class AuthGuardService implements CanActivate {

  constructor(private auth: AuthenticationService, private router: Router) { }

  canActivate(): boolean {
    if (!this.auth.IsAuthenticated()) {
      this.router.navigate(['login'], { queryParams: { returnUrl: window.location.href }});
      return false;
    }
    return true;
  }
}
